import { useState } from 'react';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { Building2, Check, ChevronDown, MapPin } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export function BranchSelector() {
  const { currentBranch, branches, setCurrentBranch } = useRestaurant();
  const [isOpen, setIsOpen] = useState(false);

  if (!branches || branches.length === 0) {
    return null;
  }

  const selectedBranch =
    branches.find((branch) => branch.id === currentBranch?.id) ||
    branches.find((branch) => branch.isMain) ||
    branches[0];

  const handleBranchSelect = (branchId: string) => {
    const selectedBranch = branches.find(b => b.id === branchId);
    if (selectedBranch) {
      setCurrentBranch(selectedBranch);
    }
    setIsOpen(false);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="flex items-center gap-2 bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 hover:border-gray-300 dark:hover:border-gray-600 transition-colors"
        >
          <Building2 className="w-4 h-4 text-gray-600 dark:text-gray-400" />
          <span className="font-medium text-gray-900 dark:text-gray-100">
            {selectedBranch?.name || 'Select Branch'}
          </span>
          <ChevronDown className="w-4 h-4 text-gray-400 dark:text-gray-500" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="flex items-center gap-2">
          <Building2 className="w-4 h-4" />
          Select Branch
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {branches.map((branch) => (
          <DropdownMenuItem
            key={branch.id}
            onClick={() => handleBranchSelect(branch.id)}
            className="cursor-pointer"
          >
            <div className="flex items-center justify-between w-full">
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2">
                  <span className="font-medium">{branch.name}</span>
                  {branch.isMain && (
                    <Badge variant="default" className="text-xs">
                      Main
                    </Badge>
                  )}
                </div>
                {branch.address && (
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <MapPin className="w-3 h-3" />
                    <span className="truncate">{branch.address}</span>
                  </div>
                )}
              </div>
              {selectedBranch?.id === branch.id && (
                <Check className="w-4 h-4 text-indigo-600" />
              )}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
